













































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { emitEvent, unregisterEvent, registerEvent, AxEventType } from '@aspenware-library/event-hub'
import { arriveParkingService } from '@/services/api/arrive-parking.service'
import { DaySelectedEventInterface } from '@/interfaces/day-selected-event.interface'

@Component({
  name: 'ArriveAvailabilityCalendar',
})
export default class ArriveAvailabilityCalendar extends Vue {
  @Prop({ default: '' })
  private height: string
  @Prop({ default: '' })
  private initialDate: string
  private autoHeight: boolean = false
  private calendarHeight: number = 0
  private aspectRatio: string
  private currentMonth: string = '8'
  private currentYear: string = '2021'
  private selectedCalendarDate: any = null
  private names: any = ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party']
  private serviceAvailability: any = {}
  private selectedDay: any = {}
  private availabilityCache: any = {}

  private async fetchAvailability(year = this.currentYear, month = this.currentMonth) {
    var previousMonth = parseInt(month, 0) - 1
    var previousMonthYear = year
    if (previousMonth <= 0) {
      previousMonth = previousMonth <= 0 ? 12 : previousMonth
      var previousMonthYearNumber = parseInt(year) - 1
      previousMonthYear = previousMonthYearNumber.toString()
    }

    const previousMonthDateKey = `${previousMonthYear}-${previousMonth}-1`
    let previousMonthAvailability = this.availabilityCache[previousMonthDateKey]
    if (!previousMonthAvailability) {
      previousMonthAvailability = await arriveParkingService.getAvailability(previousMonthDateKey)
      this.availabilityCache[previousMonthDateKey] = previousMonthAvailability
    }

    const currentMonthDateKey = `${year}-${month}-1`
    let currentMonthAvailability = this.availabilityCache[currentMonthDateKey]
    if (!currentMonthAvailability) {
      currentMonthAvailability = await arriveParkingService.getAvailability(currentMonthDateKey)
      this.availabilityCache[currentMonthDateKey] = currentMonthAvailability
    }

    const currentMonthIndex = parseInt(month, 0)
    var nextMonthIndex = currentMonthIndex + 1
    var nextMonthYear = year
    if (nextMonthIndex >= 13) {
      nextMonthIndex = 1
      var nextMonthYearNumber = parseInt(year) + 1
      nextMonthYear = nextMonthYearNumber.toString()
    }

    const nextMonthDateKey = `${nextMonthYear}-${nextMonthIndex}-1`
    let nextMonthAvailability = this.availabilityCache[nextMonthDateKey]
    if (!nextMonthAvailability) {
      nextMonthAvailability = await arriveParkingService.getAvailability(nextMonthDateKey)
      this.availabilityCache[nextMonthDateKey] = nextMonthAvailability
    }

    const twoMonthsAvailability = [...previousMonthAvailability, ...currentMonthAvailability, ...nextMonthAvailability]
    this.serviceAvailability = twoMonthsAvailability
  }

  private onResize() {
    this.calculateCalendarHeight()
  }

  private created() {
    if (this.height) {
      this.calendarHeight = parseInt(this.height, 0)
    } else {
      this.autoHeight = true
    }
    registerEvent('ASPENWARE_ARRIVE_DATEOPENED', this.calculateCalendarHeight)
  }

  private mounted() {
    this.calculateCalendarHeight()
  }

  private calculateCalendarHeight() {
    if (this.autoHeight) {
      const element: any = this.$refs.calendarWrapper as object
      const width: number = element.$el.clientWidth
      this.calendarHeight = width - 40
    }
  }

  get wrapperWidth(): number {
    const element: any = this.$refs.calendarWrapper as object
    return element.$el.clientWidth
  }

  get currentMonthName(): string {
    const monthNum = parseInt(this.currentMonth, 0) - 1
    const yearNum = parseInt(this.currentYear, 0)
    const testDate = new Date(yearNum, monthNum, 1)
    const monthName = testDate.toLocaleString('default', { month: 'long' })
    return monthName
  }

  @Watch('initialDate', { immediate: true })
  private async setInitialDate(newDate, oldDate) {
    if (newDate && oldDate !== newDate) {
      const iDate = new Date(newDate)
      const iMonth: number = iDate.getMonth() + 1
      const iYear: number = iDate.getFullYear()
      const iDay: number = iDate.getDate()
      await this.fetchAvailability(iYear.toString(), iMonth.toString())
      this.selectDay(iYear, iMonth, iDay)
    }
  }

  private selectDay(selYear, selMonth, selDay) {
    const monthValue = String(parseInt(selMonth, 0)).padStart(2, '0')
    const dayValue = String(parseInt(selDay, 0)).padStart(2, '0')
    const dateKey = `${selYear}-${monthValue}-${dayValue}`
    const availabilityInfo =
      this.serviceAvailability && this.serviceAvailability.length > 0
        ? this.serviceAvailability.find((obj) => obj.date === dateKey)
        : null
    const daySelectedEvent: DaySelectedEventInterface = {
      date: dateKey,
      year: selYear,
      month: selMonth,
      day: selDay,
      availability: availabilityInfo,
    }

    this.selectedDay = daySelectedEvent
    this.$emit('ASPENWARE_ARRIVE_DAYSELECTED', daySelectedEvent)
    emitEvent('ASPENWARE_ARRIVE_DAYSELECTED', daySelectedEvent)
  }

  private calendarChanged(data) {
    this.currentMonth = data.start.month
    this.currentYear = data.start.year
    this.fetchAvailability()
  }

  private prev() {
    const calendar = this.$refs.calendar as any
    calendar.prev()
  }

  private next() {
    const calendar = this.$refs.calendar as any
    calendar.next()
  }

  private isAvailable(year, month, day): boolean {
    const monthValue = String(parseInt(`${month}`, 0)).padStart(2, '0')
    const dayValue = String(parseInt(`${day}`, 0)).padStart(2, '0')
    const dateKey = `${year}-${monthValue}-${dayValue}`
    return this.serviceAvailability && this.serviceAvailability.length > 0
      ? this.serviceAvailability.some((obj) => obj.date === dateKey)
      : false
  }

  private lowestPrice(year, month, day): string {
    const dateKey = `${year}-${month}-${day}`
    const availabilityInfo =
      this.serviceAvailability && this.serviceAvailability.length > 0
        ? this.serviceAvailability.find((obj) => obj.date === dateKey)
        : null
    return availabilityInfo ? `$ ${availabilityInfo?.lowestPrice}` : ''
  }
}
